import useAxios from "axios-hooks";
import { useEffect, useState } from "react";
import { Resource } from "../../../../api/common";
import {
   Button,
   Col,
   Dropdown,
   Menu,
   Image,
   //    message,
   // Popover,
   Row
} from "antd";
import { useTranslation } from "react-i18next";
import React from "react";
import { EllipsisOutlined, CalendarOutlined } from "@ant-design/icons";
import { OrderDetailsModal } from "./OrderDetailsModal";
import moment from "moment";
import { truncate } from "../../../../utils/textUtils";
import { RequestComments } from "./Drawer/RequestComments";
import { getImagePath } from "../../../../utils/getImagePath";

const OrderList = (props: any) => {
   const { data, isPrivateOwner, getData } = props;
   const { id } = data;
   const [t] = useTranslation();
   const [requestData, setRequestData] = useState<any>();
   const [allRequests, setallRequests] = useState<any>([]);
   const [requestStatus, setRequestStatus] = useState(data.status);
   const [requestPaid] = useState(data.paid);
   const [showOrderDetails, setShowOrderDetails] = useState(false);
   const [showRequestComments, setShowRequestComments] =
      useState<boolean>(false);

   useEffect(() => {
      if (isPrivateOwner) {
         setRequestData(data.requestData[0]);
         setallRequests(data.requestData);
      } else {
         setRequestData(data.requestData[0]);
         setallRequests(data.requestData);
      }
   }, [data]);

   const [{ loading: updateRequestLoading }, updateRequestStatus] = useAxios(
      {
         url: `${Resource.path.updateRequest(
            data.building_id,
            data.operations_id,
            data.selling_id,
            data.id
         )}`,
         method: "POST"
      },
      { manual: true }
   );

   const [{ loading: deleteRequestLoading }, deleteRequest] = useAxios(
      {
         url: `${Resource.path.removeRequest(data.id)}`,
         method: "DELETE"
      },
      { manual: true }
   );

   const updateRequest = async (status: any) => {
      await updateRequestStatus({
         data: {
            status,
            comment: "",
            action_by: "SOURCING"
         }
      })
         .then(() => {
            setRequestStatus(status);
         })
         .catch((error) => {
            console.log(error);
         });
   };

   const reqestItemMenu = (
      <Menu className="more-menu">
         {!isPrivateOwner && (
            <Menu.Item key="1">{t("demands.customerSupport")}</Menu.Item>
         )}
         <Menu.Item
            key="2"
            disabled={data.status != "REQUESTED"}
            onClick={async () => {
               await updateOrder({
                  data: {
                     status: "DECLINED"
                  }
               });
               await getData();
            }}
         >
            {t("demands.cancelOrder")}
         </Menu.Item>
      </Menu>
   );

   const [{ loading: updateOrderLoading }, updateOrder] = useAxios(
      {
         url: `${Resource.path.updateOrderApi(data.id)}`,
         method: "POST"
      },
      { manual: true }
   );

   const buy = async () => {
      await updateOrder({
         data: {
            status: "ORDERED",
            paid: 1,
            paid_amount: getTotalPrice() + (data?.servicesCost?.shipping || 0)
         }
      });
      await getData();
   };
   const reserve = async () => {
      await updateOrder({
         data: {
            status: "ORDERED",
            reserved: 1,
            amount_reserved:
               ((getTotalPrice() + (data?.servicesCost?.shipping || 0)) * 20) /
               100
         }
      });
      await getData();
   };
   const close = async () => {
      await updateOrder({
         data: {
            status: "DELIVERED"
         }
      });
      await getData();
   };

   const insertStatusText = (state: any, data: any) => {
      console.log(data);
      switch (state) {
         case "ACCEPTED":
            return `${t("demands.checkingRequest")} ...`;
         case "REQUESTED":
            return `${t("demands.checkingRequest")} ...`;
         case "ORDERED":
            console.log(data);
            if (
               Object.values(data?.invoices).length > 0 &&
               data?.invoice_deposit == 1 &&
               data?.reserved == 0 &&
               data?.amount_reserved > 0
            ) {
               return `${t("demands.waitPayment")} ...`;
            } else if (
               Object.values(data?.invoices).length > 0 &&
               data?.invoice_payment == 1 &&
               data?.paid == 0 &&
               data?.paid_amount > 0
            ) {
               return `${t("demands.waitPayment")} ...`;
            } else if (
               Object.values(data?.invoices).length > 0 &&
               data?.paid === 1 &&
               data?.servicesAirtable &&
               data?.servicesAirtable?.shipping?.delivery_date
            ) {
               return `${t("demands.inDelivery")} ...`;
            } else if (
               Object.values(data?.invoices).length > 0 &&
               data?.paid === 1 &&
               data?.servicesAirtable &&
               !data?.servicesAirtable?.pickup?.date &&
               !data?.servicesAirtable?.shipping?.delivery_date &&
               (data?.servicesAirtable?.deconstruction?.date ||
                  data?.servicesAirtable["self-deconstruction"]?.date)
            ) {
               return `${t("demands.readyDeconstruction")} ...`;
            } else if (
               Object.values(data?.invoices).length > 0 &&
               data?.paid === 1 &&
               data?.servicesAirtable &&
               data?.servicesAirtable?.pickup?.date &&
               data?.servicesAirtable["self-deconstruction"]?.date
            ) {
               return `${t("demands.readyDeconstructionPickUp")} ...`;
            } else if (
               data?.invoice_deposit === 0 &&
               data?.reserved === 0 &&
               data?.amount_reserved
            ) {
               return `${t("demands.preparingInvoice")} ...`;
            } else if (
               data?.invoice_payment === 0 &&
               data?.paid === 0 &&
               data?.paid_amount
            ) {
               return `${t("demands.preparingInvoice")} ...`;
            } else {
               return `${t("demands.preparingOrder")} ...`;
            }
         case "CANCELLED":
            return `${t("demands.refunding")} ...`;

         default:
            return "";
      }
   };

   const showOrderStatusLabel = (status: any) => {
      switch (status) {
         case "REQUESTED":
         case "AVAILABLE":
            return (
               <span className="status-tag requested">
                  {t("demands.requested")}
               </span>
            );
         case "ACCEPTED":
            return (
               <span className="status-tag accepted">
                  {t("demands.accepted")}
               </span>
            );
         case "IN-PROGRESS":
            return (
               <span className="status-tag ordered">
                  {t("demands.ordered")}
               </span>
            );
         case "ORDERED":
            return (
               <span className="status-tag ordered">
                  {t("demands.ordered")}
               </span>
            );
         case "DELIVERED":
            return (
               <span className="status-tag closed">{t("demands.closed")}</span>
            );
         case "FAILED":
         case "DECLINED":
            return (
               <span className="status-tag cancelled">
                  {t("demands.cancelled")}
               </span>
            );
      }
   };

   const totalPieces = () => {
      return allRequests
         ? allRequests
              .reduce(
                 (a: any, b: { [x: string]: any }) => a + (+b["amount"] || 0),
                 0
              )
              .toLocaleString()
         : 0;
   };

   const getPrice = (item: any) => {
      /*       let deconstructionCost = 0;
      if (
         item?.deconstructability &&
         item?.deconstructability === "loose (easy)"
      ) {
         deconstructionCost = 1;
      } else if (
         item?.deconstructability &&
         [
            "built-in (easy)",
            "built-in (moderate)",
            "built-in (elaborate)"
         ].indexOf(item?.deconstructability) !== -1 &&
         item?.third_party_deconstruction
      ) {
         deconstructionCost = 1;
      } else {
         deconstructionCost = 0;
      }
      return (
         (+item?.selling_price -
            ((+item?.demands_target_price ? +item?.demands_target_price : 0) -
               (+item?.deconstruction_costs || item?.pg_deconstruction_costs) *
                  deconstructionCost)) *
         +item?.amount
      ); */
      let deconstructionCost = 0;
      if (item.deconstruction_type === "provided") {
         deconstructionCost = 1;
      }
      //console.log('selectedItems', selectedItems);
      return (
         item?.selling_price * item.amount +
         (item.deconstruction_costs || item.pg_deconstruction_costs) *
            deconstructionCost *
            item.amount
      );
   };

   const getTotalPrice = () => {
      let total = 0;
      const items_price = allRequests
         ? allRequests.map((item: any) => (item.price = getPrice(item)))
         : [];
      total = items_price.length
         ? items_price.reduce((a: any, b: any) => a + b, 0)
         : 0;
      return total;
   };

   if (deleteRequestLoading || updateOrderLoading) {
      (window as any).NProgress.start();
   } else {
      (window as any).NProgress.done();
   }

   return (
      <>
         <Row className="order-wrapper inner sourcing">
            <Col span={8}>
               <div
                  className="hover-state"
                  onClick={() => setShowOrderDetails(true)}
               >
                  <span className="request-id">#{id}</span>
                  <div className="order-status-label">
                     {showOrderStatusLabel(data.status)}
                  </div>
                  <div className="item-info">
                     <figure className="">
                        {/* {requestData?.images ? (
                           <img src={requestData?.images[0]?.object_url} />
                        ) : (
                           <img src="data:image/png;base64,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" />
                        )} */}
                        <Image
                           src={
                              requestData?.images?.length
                                 ? getImagePath(requestData?.images[0])
                                 : "error"
                           }
                           fallback="data:image/png;base64,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"
                        />
                     </figure>
                     <div className="order-title">
                        <strong>{`${requestData?.product_name}`}</strong>
                        <span className="amount">
                           {isPrivateOwner
                              ? requestData?.amount
                              : totalPieces()}{" "}
                           {t(
                              requestData?.amount_unit == "Stück"
                                 ? t("demands.pieces")
                                 : requestData?.amount_unit
                           )}
                        </span>
                     </div>
                  </div>
               </div>
            </Col>
            <Col span={9}>
               <div className="d-flex payment-info">
                  <div className="d-flex price-info">
                     <>
                        <span className="price">{`${
                           isPrivateOwner
                              ? getTotalPrice().toLocaleString()
                              : (
                                   getTotalPrice() +
                                   (data?.servicesCost?.shipping
                                      ? data?.servicesCost?.shipping
                                      : 0)
                                ).toLocaleString()
                        } €`}</span>
                        {!isPrivateOwner && (
                           <>
                              {data.deconstruction_type == "provided" &&
                                 data.logistics_type == "shipping" && (
                                    <span className="shipping">
                                       {data?.servicesCost?.shipping
                                          ? ` (${t("demands.incleShipping")})`
                                          : ` + ${t(
                                               "demands.pendingShippingCosts"
                                            )} `}
                                    </span>
                                 )}
                              {data?.logistics_type == "pickup" && (
                                 <span>
                                    <>
                                       {data?.deconstruction_type == "self" ? (
                                          <>
                                             {`(${t(
                                                "demands.selfDeconstruction"
                                             ).toLowerCase()} & ${t(
                                                "demands.pickup"
                                             )})`}
                                          </>
                                       ) : (
                                          <>{`(${t("demands.pickup")})`}</>
                                       )}
                                    </>
                                 </span>
                              )}
                           </>
                        )}
                     </>
                     <div className="status">
                        {data.status == "ACCEPTED" &&
                           !data.paid &&
                           !data.reserved && (
                              <span className="status-tag pink">
                                 {t("default.open").toLocaleLowerCase()}
                              </span>
                           )}
                        {data.paid &&
                        data.paid_amount &&
                        data.status != "DELIVERED" ? (
                           <span className="status-tag green">
                              {t("demands.paid")}
                           </span>
                        ) : null}
                        {!data.paid &&
                        data.reserved &&
                        data.amount_reserved &&
                        data.status != "DELIVERED" ? (
                           <span className="status-tag green">{`${t(
                              "demands.depositPaid"
                           )} (${data.amount_reserved}€) `}</span>
                        ) : null}
                        {data.refunded ? (
                           <span className="status-tag green">
                              {t("demands.refunded")}
                           </span>
                        ) : null}
                     </div>
                  </div>
                  {data.deconstruction_type == "self" && !isPrivateOwner ? (
                     <>
                        {!data?.servicesAirtable["self-deconstruction"]
                           ?.date ? (
                           <div className="self-deconst border">
                              {`${t("demands.selfDeconstructionPossible")} ${t(
                                 "default.between"
                              )} ${moment(
                                 requestData?.self_start_date_deconstruction
                              ).format("DD/MM/YYYY")} - ${moment(
                                 requestData?.self_end_date_deconstruction
                              ).format("DD/MM/YYYY")}`}
                           </div>
                        ) : (
                           <div className="self-deconst">
                              <CalendarOutlined />
                              {`${t("demands.selfDeconstruction")} ${t(
                                 "default.on"
                              )} ${moment(
                                 data?.servicesAirtable["self-deconstruction"]
                                    ?.date
                              ).format("DD/MM/YYYY")} - ${truncate(
                                 `${data.delivery_address.street}, ${data.delivery_address.zip} ${data.delivery_address.city}`,
                                 30
                              )}`}
                           </div>
                        )}
                     </>
                  ) : (
                     <>
                        {!isPrivateOwner &&
                           data.status != "DECLINED" &&
                           data.status != "DELIVERED" && (
                              <div>
                                 {!data?.servicesAirtable?.pickup?.date
                                    ? data.logistics_type == "pickup" && (
                                         <div className="pickup border">
                                            {t("demands.pickupDateNotSet")}
                                         </div>
                                      )
                                    : data.logistics_type == "pickup" && (
                                         <div className="pickup">
                                            <CalendarOutlined />
                                            {`${t("demands.pickup")} ${t(
                                               "default.on"
                                            )} ${moment(
                                               data?.servicesAirtable?.pickup
                                                  ?.date
                                            ).format("DD/MM/YYYY")}`}
                                         </div>
                                      )}
                              </div>
                           )}
                     </>
                  )}
               </div>
            </Col>
            <Col span={7}>
               <div className="last-col">
                  <span className="info-text">
                     {!isPrivateOwner &&
                        !(
                           data.status == "ACCEPTED" &&
                           !data.amount_reserved &&
                           !data.paid
                        ) &&
                        !(
                           data.status == "ORDERED" &&
                           data.reserved === 1 &&
                           data?.paid === 0 &&
                           data?.paid_amount === 0
                        ) &&
                        insertStatusText(data.status, data)}
                  </span>
                  <div>
                     {/* TODO: check for buttons condition */}
                     {isPrivateOwner ? (
                        <>
                           <Button
                              type="default"
                              className="shadow-button"
                              onClick={() => {
                                 setShowRequestComments(true);
                              }}
                           >
                              chat
                           </Button>
                        </>
                     ) : (
                        <>
                           {data.status == "ACCEPTED" &&
                           !data.amount_reserved &&
                           !data.paid ? (
                              <Button //reserve
                                 className="shadow-button"
                                 onClick={() => reserve()}
                                 disabled={!data.airtable_id}
                              >
                                 {t("demands.reserve")} (
                                 {((getTotalPrice() +
                                    (data?.servicesCost?.shipping || 0)) *
                                    20) /
                                    100}{" "}
                                 € {t("demands.deposit")})
                              </Button>
                           ) : null}
                           {data.status == "ACCEPTED" && !data.paid ? (
                              <Button //buy
                                 className="shadow-button"
                                 onClick={() => buy()}
                                 disabled={!data.airtable_id}
                              >
                                 {" "}
                                 {t("demands.buy")}
                              </Button>
                           ) : null}
                           {data.status == "ORDERED" &&
                           data.reserved === 1 &&
                           data?.paid === 0 &&
                           data?.paid_amount === 0 ? (
                              <Button //buy
                                 className="shadow-button"
                                 onClick={() => buy()}
                                 disabled={!data.airtable_id}
                              >
                                 {" "}
                                 {t("demands.buy")}
                              </Button>
                           ) : null}
                           {data?.servicesAirtable &&
                           data.paid &&
                           data.status !== "DELIVERED" &&
                           (data?.servicesAirtable?.shipping?.delivery_date ||
                              (data?.servicesAirtable &&
                                 data?.servicesAirtable?.pickup?.date &&
                                 data?.servicesAirtable["self-deconstruction"]
                                    ?.date)) ? (
                              <Button //close
                                 className="shadow-button orange"
                                 onClick={() => close()}
                              >
                                 {t("default.close").toLocaleLowerCase()}
                              </Button>
                           ) : null}
                        </>
                     )}
                  </div>
                  <div style={{ position: "relative", height: "30px" }}>
                     <Dropdown
                        overlay={reqestItemMenu}
                        placement="topLeft"
                        trigger={["click"]}
                     >
                        <Button
                           className="more-button"
                           type="link"
                           icon={
                              <EllipsisOutlined style={{ fontSize: "25px" }} />
                           }
                        ></Button>
                     </Dropdown>
                  </div>
               </div>
            </Col>
         </Row>
         {showOrderDetails && (
            <OrderDetailsModal
               visible={showOrderDetails}
               onCancel={() => setShowOrderDetails(false)}
               requestData={requestData}
            />
         )}
         {isPrivateOwner && !!showRequestComments && (
            <RequestComments
               data={data}
               visible={showRequestComments}
               onClose={() => {
                  setShowRequestComments(!showRequestComments);
               }}
               created_by_type="BUYER"
            />
         )}
      </>
   );
};

export default OrderList;
